import {createAction, props} from '@ngrx/store';
import {ProductQuery} from '../common/context-data';
import {CommerceErrorInterface} from '../common/error-handling/commerce-error';
import {
  ProductComponentModel,
  ProductType,
  Specification,
  Variant,
} from '../data/model';

export const loadAddon = createAction(
  '[AddOn] Load Add-On',
  props<{catalogId: string}>(),
);

export const loadAddonSuccess = createAction(
  '[AddOn] Load Add-On Success',
  props<{addon: ProductComponentModel<ProductType>}>(),
);

export const loadAddonFailed = createAction(
  '[AddOn] Load Add-On Failed',
  props<{
    catalogId: string;
    error: unknown;
  }>(),
);

/**
 * @deprecated This action is no longer used and will be removed in future versions
 */
export const loadAddOns = createAction(
  '[AddOn] Load AddOns',
  props<{query: ProductQuery}>(),
);

export const loadAddOnsSuccess = createAction(
  '[AddOn] Load Add-Ons Success',
  props<{addOns: ProductComponentModel<ProductType>[]}>(),
);

export const loadAddOnsFailure = createAction(
  '[AddOn] Load Add-Ons Failure',
  props<{
    error: CommerceErrorInterface;
  }>(),
);

export const loadSpecs = createAction(
  '[AddOn] Load Specs',
  props<{productId: string}>(),
);

export const loadSpecsSuccess = createAction(
  '[AddOn] Load Specs Success',
  props<{specs: Specification[]; productId: string}>(),
);

export const loadSpecsFailure = createAction(
  '[AddOn] Load Specs Failure',
  props<{error: CommerceErrorInterface}>(),
);

export const externalRedirect = createAction('[AddOnAction] External Redirect');

export const nextAddOn = createAction('[AddOn] Display Next Add-on');

export const previousAddOn = createAction('[AddOn] Display Previous Add-on');

export const initializationStart = createAction('[AddOn] Initialization start');

export const initializationComplete = createAction(
  '[AddOn] Initialization complete',
);

export const loadVariants = createAction(
  '[AddOn] Load product variants',
  props<{productId: string}>(),
);

export const loadVariantsSuccess = createAction(
  '[AddOn] Load product variants success',
  props<{variants: Variant[]; productId: string}>(),
);

export const loadVariantsFailed = createAction(
  '[AddOn] Load product variants failed',
  props<{
    error: CommerceErrorInterface;
  }>(),
);

export const showLoadingIndicator = createAction(
  '[AddOn] Show Loading Indicator',
);
export const hideLoadingIndicator = createAction(
  '[AddOn] Hide Loading Indicator',
);
